module.exports = __webpack_public_path__ + "df28cc2d78aa7d98c92dca5cca551f1c.woff2";